import React from 'react';

const ButtonOnOff = ({ isOn, onToggle }) => {
  return (
    <label className="switch">
      <input 
        type="checkbox" 
        checked={isOn} 
        onChange={onToggle} 
      />
      <span className="slider round"></span>
    </label>
  );
};

export default ButtonOnOff;
